exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._3FvMZg7uMpcZIftMNq0elH{color:#a4a4a4;font-size:1.14286rem;margin-bottom:1.42857rem;padding-top:5rem;text-align:center}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"NoContentMessage": "_3FvMZg7uMpcZIftMNq0elH"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/_omni-operation-ui_release_2.7.3/node_modules/omni-common-ui/postcss.config.js"}}!./components/NoContentMessage/style.postcss
// module id = 1463
// module chunks = 0